<!-- eslint-disable -->
<template>
      <div class="page-content">
        <section class="row">
          <div class="col-12 col-lg-8">
            
            <div class="card">
              <ul class="list-group list-group-flush">
                <li class="list-group-item" v-for="row in dataRincian" :key="row.kodeDetailTagihan" v-show="row.kodeDetailTagihan !== 1">
                    <small>{{ row.deskripsiPanjang }}</small><br><label class="label-info">Rp. {{ $filters.currencyUSD(row.nominal) }}</label>
                </li>
              </ul>
            </div>
            <div class="card">
              <div class="card-body px-3 py-4-5">
                <div class="row">
                  <div class="col-md-4">
                    <div class="stats-icon red">
                      <i class="iconly-boldBuy"></i>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <h6 class="text-muted font-semibold">Total Tagihan belum dibayar</h6>
                    <h6 class="font-extrabold mb-0">{{ $filters.currencyUSD(dataJumlah)  }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
</template>
<!-- eslint-disable -->
<script>
export default {
  name: "RincianTagihan",
  props: {
    dataRincian: Array,
    dataJumlah : 0
  }
};
</script>